import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  screen: { flex: 1, backgroundColor: "transparent" },
  content: { padding: 16, paddingTop: 28, paddingBottom: 32, gap: 16 },
  apiMessage: { color: "#666666", fontFamily: "Archivo-Regular", fontSize: 11 },
  headerActions: { flexDirection: "row", alignItems: "center", gap: 10 },
  avatar: {
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: "#FFFFFF",
    alignItems: "center",
    justifyContent: "center",
  },
  inputData: {
    height: 42,
    paddingHorizontal: 14,
    borderRadius: 24,
    backgroundColor: "#FFFFFF",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  inputDataText: { color: "#151515", fontFamily: "Archivo-Bold", fontSize: 12 },
  greeting: { paddingTop: 12, paddingBottom: 10 },
  greetingTitle: { color: "#111111", fontFamily: "Archivo-Bold", fontSize: 21 },
  greetingSubtitle: {
    color: "#171717",
    fontFamily: "Archivo-Regular",
    fontSize: 20,
    marginTop: 2,
  },
  schoolPeriodCard: {
    paddingHorizontal: 16,
    borderRadius: 17,
    backgroundColor: "#FFFFFF",
    elevation: 2,
    shadowColor: "#34234A",
    shadowOpacity: 0.08,
    shadowRadius: 5,
    shadowOffset: { width: 0, height: 2 },
  },
  schoolInfo: {
    minHeight: 60,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  schoolLogo: { width: 68, height: 20 },
  nihiisSchoolInfo: { gap: 8 },
  nihiisSchoolLogo: { width: 24, height: 24 },
  schoolDivider: { width: 1, height: 28, backgroundColor: "#E7E7E7" },
  schoolName: {
    flex: 1,
    color: "#353535",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
  },
  schoolPeriodDivider: { height: 1, backgroundColor: "#E7E7E7" },
  seeAllButton: { borderRadius: 16 },
  card: {
    padding: 14,
    borderRadius: 17,
    backgroundColor: "#FFFFFF",
    elevation: 2,
    shadowColor: "#34234A",
    shadowOpacity: 0.08,
    shadowRadius: 5,
    shadowOffset: { width: 0, height: 2 },
  },
  sectionHeading: {
    minHeight: 28,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  iconTile: {
    width: 22,
    height: 22,
    borderRadius: 5,
    backgroundColor: "#F0E9FF",
    alignItems: "center",
    justifyContent: "center",
  },
  sectionTitle: {
    flex: 1,
    color: "#171717",
    fontFamily: "Archivo-Bold",
    fontSize: 12,
  },
  seeAll: {
    overflow: "hidden",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 15,
    color: "#6724E2",
    backgroundColor: "#F0E9FF",
    fontFamily: "Archivo-Regular",
    fontSize: 9,
  },
  progressTrack: {
    height: 20,
    marginTop: 12,
    borderRadius: 12,
    backgroundColor: "#F0F0F0",
    overflow: "hidden",
  },
  progressValue: {
    height: "100%",
    borderRadius: 12,
    backgroundColor: "#5423B5",
  },
  progressLabels: {
    marginTop: 7,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  bodyText: { color: "#202020", fontFamily: "Archivo-Regular", fontSize: 11 },
  bold: { fontFamily: "Archivo-Bold" },
  statsDivider: { height: 1, marginTop: 12, backgroundColor: "#EEEEEE" },
  statColumns: { flexDirection: "row", marginTop: 12 },
  statColumn: { flex: 1, gap: 4 },
  statLabelRow: { flexDirection: "row", alignItems: "center", gap: 8 },
  smallIconTile: {
    width: 24,
    height: 24,
    borderRadius: 5,
    backgroundColor: "#F6F6F6",
    alignItems: "center",
    justifyContent: "center",
  },
  statLabel: { color: "#171717", fontFamily: "Archivo-Bold", fontSize: 12 },
  statValue: {
    marginTop: 2,
    color: "#111111",
    fontFamily: "Archivo-Bold",
    fontSize: 17,
  },
  achieved: { color: "#48B920", fontFamily: "Archivo-Regular", fontSize: 12 },
  listDivider: {
    height: 1,
    marginTop: 10,
    marginBottom: 6,
    backgroundColor: "#EEEEEE",
  },
  segmentRow: { flexDirection: "row", gap: 10, marginTop: 12, marginBottom: 4 },
  segment: {
    position: "relative",
    flex: 1,
    minHeight: 50,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderColor: "#E7E7E7",
    borderRadius: 9,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  segmentPositiveActive: { borderColor: "#48B920", backgroundColor: "#FFFFFF" },
  segmentAttentionActive: {
    borderColor: "#E24B4B",
    backgroundColor: "#FFFFFF",
  },
  segmentUnderline: {
    position: "absolute",
    left: 16,
    right: 16,
    bottom: 2,
    height: 4,
    borderRadius: 3,
  },
  positiveUnderline: { backgroundColor: "#48B920" },
  attentionUnderline: { backgroundColor: "#E24B4B" },
  segmentText: {
    color: "#252525",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
    lineHeight: 14,
  },
  positiveText: { color: "#48B920" },
  attentionText: { color: "#D84343" },
  characterSheet: { height: "76%" },
  periodChoice: {
    minHeight: 48,
    marginBottom: 12,
    paddingHorizontal: 14,
    borderWidth: 1,
    borderColor: "#E8E8E8",
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  periodChoiceSelected: { borderColor: "#6724E2" },
  periodChoiceText: {
    color: "#222222",
    fontFamily: "Archivo-Regular",
    fontSize: 12,
  },
  periodChoiceTextSelected: { color: "#6724E2", fontFamily: "Archivo-Bold" },
  childChoice: {
    minHeight: 62,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: "#6724E2",
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  childAvatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: "#EEEEEE",
    alignItems: "center",
    justifyContent: "center",
  },
  childDetails: { flex: 1 },
  childName: { color: "#5423B5", fontFamily: "Archivo-Bold", fontSize: 12 },
  childClass: {
    marginTop: 2,
    color: "#999999",
    fontFamily: "Archivo-Regular",
    fontSize: 11,
  },
  selectedCheck: {
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: "#48B920",
    alignItems: "center",
    justifyContent: "center",
  },
  selectedCheckText: {
    color: "#FFFFFF",
    fontFamily: "Archivo-Bold",
    fontSize: 12,
    lineHeight: 16,
  },
  characterSheetList: { flex: 1 },
  nonAcademicInfoSheet: { height: "50%", paddingBottom: 16 },
  nonAcademicInfoContent: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  largeMenuGlyph: {
    width: 60,
    height: 60,
    marginBottom: 16,
    borderRadius: 30,
    backgroundColor: "#5423B5",
    alignItems: "center",
    justifyContent: "center",
  },
  nonAcademicInfoTitle: {
    color: "#111111",
    fontFamily: "Archivo-Bold",
    fontSize: 14,
    textAlign: "center",
  },
  nonAcademicInfoDescription: {
    maxWidth: 300,
    marginTop: 8,
    color: "#111111",
    fontFamily: "Archivo-Regular",
    fontSize: 12,
    lineHeight: 18,
    textAlign: "center",
  },
});

export default styles;
